import React, { useState } from "react";
import moment from "moment";
import { DrawerForm, DrawerFormRef } from "../../../../components/drawers/DrawerForm";
import Icon from "../../../../components/base/Icon";
import { toShortDateWithoutTime, useHub } from "../../../../core/Global";
import { toastError, toastSuccess } from "../../../../components/base/Toast";
import PaymentMethodPicker from "./PaymentMethodPicker";
import CurrentPlan from "../models/CurrentPlan";
import "./PlanChange.css";


const money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })


// Bringing a paused account back. The plan's full price is charged today and it renews from
// today, so everything unlocks the moment the payment goes through.
export default function ResumeDrawer(props: {
    plan: CurrentPlan,
    drawerRef?: React.RefObject<DrawerFormRef>,
    onClose: () => void,
    onResumed: () => void
}) {

    const hub = useHub()

    const [methodId, methodIdSet] = useState<string>()
    const [loadingMethods, loadingMethodsSet] = useState<boolean>(true)

    const plan = props.plan
    const annual = plan.billing === "annual"
    const renews = toShortDateWithoutTime(moment().add(1, annual ? "years" : "months").toDate())

    const resume = (callback: any) => {
        hub.Post("/accounts/profile/plan/hold/resume", { paymentMethodId: methodId }, res => {
            callback(res)
            if (res.success) {
                toastSuccess(res.data?.message ?? "Your plan is running again.")
                props.onResumed()
            }
            else toastError(res.message ?? "Couldn't resume your account.")
        }, () => callback({ success: false }))
    }

    return (
        <DrawerForm id="drawer-plan-resume"
            ref={props.drawerRef}
            title="Resume your account"
            titleIcon="play"
            subtitle={"Paused until " + toShortDateWithoutTime(plan.holdEndsAt)}
            size="medium"
            buttonText={"Resume & Pay " + money.format(plan.price)}
            confirmDisabled={loadingMethods || !methodId}
            onClose={props.onClose}
            onSubmit={(body, callback) => resume(callback)}>

            <div className="plan-change">

                <div className="plan-change-summary mb-8">
                    <div className="plan-change-row">
                        <span>Plan</span>
                        <b>{plan.displayName ?? plan.planName}</b>
                    </div>
                    <div className="plan-change-row">
                        <span>Charged today</span>
                        <b>{money.format(plan.price)}</b>
                    </div>
                    <div className="plan-change-row">
                        <span>Next renewal</span>
                        <b>{renews}</b>
                    </div>
                </div>

                <div className="plan-change-note is-success mb-8">
                    <Icon icon="circle-check" type="solid" size={14} />
                    <div>
                        Everything unlocks as soon as the payment goes through. Your plan starts again
                        today and renews every {annual ? "year" : "month"} from today.
                    </div>
                </div>

                <div className="fw-bold mb-3">Payment Method</div>
                <PaymentMethodPicker selectedMethodId={methodId} onChange={methodIdSet}
                    onLoadingChange={loadingMethodsSet} noNewCard />
            </div>

        </DrawerForm>
    )
}
